/**
 * 模板市场首页相关接口
 */
import { get, post } from '@fe/common/lib/ajax';

const API_PREFIX = '/api/store/template';

/**
 * 获取模板推荐
 */
export function getRecommendList() {
  return get(`${API_PREFIX}/getRecommendList`);
}

/**
 * 获取轮播图
 */
export function getBannerList(bannerType: number) {
  return get(`${API_PREFIX}/getBannerList`, { bannerType });
}

/**
 * 获取热点列表
 */
export function getHotSpotList() {
  return get(`${API_PREFIX}/getHotSpotList`);
}

/**
 * 获取悬浮视频
 */
export function getSparkleVideo() {
  return get(`${API_PREFIX}/getSparkleVideo`);
}

/**
 * 获取平台专区筛选条件
 */
export function getOpenZoneFilterList() {
  return get(`${API_PREFIX}/getOpenZoneFilterList`);
}

/**
 * 获取平台专区模板数据
 */
export function getOpenZoneTplList(filters: Record<string, any>) {
  const url = `${API_PREFIX}/getOpenZoneTplList`;
  return post(url, filters);
}

/**
 * 获取企业专区筛选条件
 */
export function getOrgZoneFilterList(orgId: string) {
  return get(`${API_PREFIX}/getOrgZoneFilterList`, { orgId });
}

/**
 * 获取企业专区模板数据
 */
export function getOrgZoneTplList(filters: Record<string, any>) {
  const url = `${API_PREFIX}/getOrgZoneTplList`;
  return post(url, filters);
}

/**
 * 检查用户是否开通企业专区
 */
export function checkUserOrgZoneStatus(orgId: string) {
  return get(`${API_PREFIX}/checkUserOrgZoneStatus`, { orgId });
}
